import { IntegrationPlatform, IntegrationCategory } from "./types"

export const INTEGRATION_CATEGORIES: IntegrationCategory[] = [
  "event-management",
  "crm",
  "marketing",
  "automation",
]

export const ALL_INTEGRATIONS: IntegrationPlatform[] = [
  {
    slug: "cvent",
    name: "Cvent",
    description:
      "Turn every attendee into an event promoter with Premagic + Cvent integration",
    shortDescription:
      "Seamless event management integration with poster generation and attendee sync",
    logoUrl: "https://companieslogo.com/img/orig/CVT-1a4927ff.svg?t=1720244491",
    websiteUrl: "https://www.cvent.com/",
    category: "event-management",
    tags: ["Event Management", "Native Integration", "Bi-Directional Sync"],
    isComingSoon: false,
  },
  {
    slug: "hubspot",
    name: "HubSpot",
    description:
      "Turn contacts into event promoters with Premagic + HubSpot integration",
    shortDescription:
      "CRM integration for marketing automation and attendee advocacy",
    logoUrl: "https://www.vectorlogo.zone/logos/hubspot/hubspot-icon.svg",
    websiteUrl: "https://www.hubspot.com/",
    category: "crm",
    tags: ["CRM", "Marketing", "Bi-Directional Sync"],
    isComingSoon: false,
  },
  {
    slug: "swapcard",
    name: "Swapcard",
    description:
      "Real-time attendee activation with Premagic + Swapcard integration",
    shortDescription:
      "Event management platform with real-time webhook sync and smart filtering",
    logoUrl:
      "https://cdn.prod.website-files.com/6341448fda79c92372b010a4/63502c47c8e7bdfa7c25aefe_swapcardLogo.svg",
    websiteUrl: "https://www.swapcard.com/",
    category: "event-management",
    tags: ["Event Management", "Real-Time Webhooks"],
    isComingSoon: false,
  },
  {
    slug: "luma",
    name: "Luma",
    description:
      "Supercharge community events with Premagic + Luma integration",
    shortDescription:
      "Community event platform with automatic poster generation and guest sync",
    logoUrl: "https://cdn.brandfetch.io/lu.ma/w/512/h/512/logo",
    websiteUrl: "https://lu.ma/",
    category: "event-management",
    tags: ["Event Management", "Community Events"],
    isComingSoon: false,
  },
  {
    slug: "gatsby-events",
    name: "Gatsby Events",
    description:
      "Elevate exclusive events with Premagic + Gatsby Events integration",
    shortDescription:
      "Premium event platform with multi-organization support and custom fields",
    logoUrl:
      "https://framerusercontent.com/images/jkOE20pLGj1fhwkaeuJ0UvOM74.svg",
    websiteUrl: "https://www.gatsby.events/",
    category: "event-management",
    tags: ["Event Management", "Premium Events"],
    isComingSoon: false,
  },
  {
    slug: "grip",
    name: "Grip",
    description: "One-click poster activation with Premagic built into Grip",
    shortDescription:
      "Native integration with automatic poster widget and referral tracking",
    logoUrl:
      "https://cdn.prod.website-files.com/5fb3c15a27ce48001c749db9/651bd8f25d1d847ed18d275a_Grip-Webicon-v2.png",
    websiteUrl: "https://www.grip.events/",
    category: "event-management",
    tags: ["Event Management", "Native Integration"],
    isComingSoon: false,
  },
  {
    slug: "salesforce",
    name: "Salesforce",
    description: "Coming soon: Premagic + Salesforce integration",
    shortDescription:
      "Enterprise CRM integration for large-scale event marketing",
    logoUrl: "https://www.vectorlogo.zone/logos/salesforce/salesforce-icon.svg",
    websiteUrl: "https://www.salesforce.com/",
    category: "crm",
    tags: ["CRM", "Enterprise"],
    isComingSoon: true,
    comingSoonLabel: "Coming Soon",
  },
  {
    slug: "zapier",
    name: "Zapier",
    description: "Coming soon: Premagic + Zapier integration",
    shortDescription:
      "Automation platform for connecting Premagic with 5000+ apps",
    logoUrl: "https://www.vectorlogo.zone/logos/zapier/zapier-icon.svg",
    websiteUrl: "https://zapier.com/",
    category: "automation",
    tags: ["Automation", "Integrations"],
    isComingSoon: true,
    comingSoonLabel: "Coming Soon",
  },
]
